<template>
  <div v-on:keyup.27="hideModal()" v-if="show" class="modal animated fast fadeIn">
    <div :class="{'animated fast zoomIn': show}" class="modal__container container">
      <div v-on:click="hideModal()" class="modal__close icon-before icon-nm icon-x">x</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'Modal',
  directives: {
    ClickOutside
  },
  data: function () {
    return {
      show: false
    }
  },
  mounted(){
    let that = this;
    document.addEventListener('keyup', function(e){
      if (e.code === 27) {
        that.hideModal();
      }
    });
  },
  methods: {
    showModal(){
      this.show = true;
    },
    hideModal(){
      this.$emit('hide');
      this.show = false;
    }
  }
}
</script>
